import React from 'react';
import { copyFor } from 'config';
import { Crate, FlexCrate, Icon, Tooltip } from '@perch-labs/shrike';
import {
  StyledListItem,
  StyledContainer,
  StyledHeading,
  StyledSupportingText,
  StyledText,
  StyledTooltipContainer,
} from '../line-items.style';
import { ArrowIcon } from '../arrow-icon';
import { LineItemAmount } from '../line-item-amount.component';

interface Props {
  lineItems: Array<OtherLineItem>;
  includeTooltips: boolean;
  includeSupportingText: boolean;
}
const getCopy = copyFor('billing.statement.lineItems.extras');

export const ExtrasLineItem = ({
  lineItems,
  includeTooltips,
  includeSupportingText,
}: Props) => {
  if (lineItems.length === 0) {
    return null;
  }

  const tooltipCopy = getCopy('tooltip.copy');

  return (
    <StyledListItem data-testid="extras-line-item">
      <StyledContainer>
        <FlexCrate flexDirection="column" gap="8px">
          <StyledTooltipContainer>
            <StyledHeading>{getCopy('title')}</StyledHeading>
            {includeTooltips && (
              <Tooltip
                content={tooltipCopy}
                tooltipId="arcadiaExtras"
                label={getCopy('tooltip.label')}
              >
                <Icon icon="InfoCircleInverted" />
              </Tooltip>
            )}
          </StyledTooltipContainer>
          {includeSupportingText && (
            <Crate padding="0 64px 0 0">
              <StyledSupportingText>{tooltipCopy}</StyledSupportingText>
            </Crate>
          )}
        </FlexCrate>
      </StyledContainer>
      <FlexCrate
        flexDirection="column"
        margin={{ top: '16px' }}
        gap="16px"
        width="100%"
      >
        {lineItems.map(lineItem => (
          <StyledContainer key={lineItem.id}>
            <StyledTooltipContainer>
              <StyledText>
                {' '}
                <ArrowIcon />
                {includeSupportingText ? <b>{lineItem.name}</b> : lineItem.name}
              </StyledText>
            </StyledTooltipContainer>
            <LineItemAmount amountCents={lineItem.amountCents} />
          </StyledContainer>
        ))}
      </FlexCrate>
    </StyledListItem>
  );
};
